import classNames from 'classnames';
import * as React from 'react';

import './styles.scss';

type Props = {
    size?: 'small' | 'medium' | 'large'
    dotColor?: 'default' | 'light' | 'primary' | 'success';
    className?: string;
};

export const LoadingDots: React.FC<Readonly<Props>> = ({className, dotColor = 'default', size = 'small'}: Readonly<Props>) => (
    <span className={classNames('vs-loading-dots', `dot-color-${dotColor}`, size, className)}>
        <i className='dot left' />
        <i className='dot center' />
        <i className='dot right' />
    </span>
);
